<template>
    <div class="flex items-center justify-around flex-shrink-0 p-10 text-white">
        <a href="/">
            <img width="185" src="https://landen.imgix.net/49sdd8m56kjh/assets/ijez73sh.svg?w=370" />
        </a>
        <div class="flex items-center hidden text-sm lg:block">
            <span class="text-gray-600">
                Not using Flowist?
            </span>
            <router-link tag="a" class="font-bold text-gray-600 underline" to="/signup">
                Sign up
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'signin-header',
    data() {
        return {};
    },
};
</script>
